import React from 'react';

export const TopAnnouncementBar = () => {
  return (
    <div className="fixed top-0 left-0 right-0 w-full bg-red-600 py-3 md:py-4 text-center z-[60] shadow-md">
      <p className="text-white text-base sm:text-lg md:text-xl font-bold px-4 animate-blink">
        Dubai&apos;s #1 German Vehicle Experts
      </p>
      
      <style>{`
        @keyframes blink {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.3;
          }
        }
        
        .animate-blink {
          animation: blink 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};
